module.exports = __webpack_public_path__ + "static/media/plan.6cf93bce.png";